class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    if (!this.section) this.section = this.closest('.product-page') || document;

    if (this.parentElement !== document.body) {
      document.body
        .querySelectorAll(':scope > product-sticky-bar')
        .forEach((stale) => stale.remove());
      document.body.appendChild(this);
      return;
    }

    this.select = this.querySelector('[data-sticky-select]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.submit = this.querySelector('[data-sticky-submit]');

    this.realSubmit = this.section.querySelector('.js-ajax-submit');
    this.realPrice = this.section.querySelector('#product-price');

    if (!this.realSubmit) return;

    this.bindSelect();
    this.bindSubmit();
    this.watchPrice();
    this.watchVisibility();
  }

  disconnectedCallback() {
    this.priceObserver?.disconnect();
    this.visibilityObserver?.disconnect();
  }

  swatchInputs() {
    if (!this.select) return [];
    const position = this.select.dataset.optionPosition;
    return Array.from(
      this.section.querySelectorAll(`.swatches__form--input[data-position="${position}"]`)
    );
  }

  bindSelect() {
    if (!this.select) return;

    this.select.addEventListener('change', () => {
      const input = this.swatchInputs().find((el) => el.value === this.select.value);
      if (input && !input.checked) input.click();
    });

    this.swatchInputs().forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) this.select.value = input.value;
      });
    });
  }

  bindSubmit() {
    this.submit.addEventListener('click', () => {
      if (this.select && !this.select.value) {
        this.select.focus();
        return;
      }

      this.realSubmit.click();
    });
  }

  watchPrice() {
    if (!this.realPrice || !this.priceEl) return;

    const sync = () => {
      const onSale = this.realPrice.classList.contains('price--on-sale');
      const source = onSale
        ? this.realPrice.querySelector('[data-sale-price]')
        : this.realPrice.querySelector('[data-regular-price]');

      const text = source?.textContent.replace(/\s+/g, ' ').trim();
      if (text) this.priceEl.textContent = text;
    };

    sync();

    this.priceObserver = new MutationObserver(sync);
    this.priceObserver.observe(this.realPrice, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  watchVisibility() {
    const anchor = this.realSubmit.closest('form') || this.realSubmit;

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        this.hidden = entry.isIntersecting;
      },
      { rootMargin: '0px 0px -80px 0px' }
    );

    this.visibilityObserver.observe(anchor);
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
